import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=898347f6&scoped=true&"
import script from "./MiPerfil.vue?vue&type=script&lang=ts&"
export * from "./MiPerfil.vue?vue&type=script&lang=ts&"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=898347f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898347f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('898347f6', component.options)
    } else {
      api.reload('898347f6', component.options)
    }
    module.hot.accept("./MiPerfil.vue?vue&type=template&id=898347f6&scoped=true&", function () {
      api.rerender('898347f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/MiPerfil.vue"
export default component.exports